import { render, staticRenderFns } from "./message-list.vue?vue&type=template&id=25b5bc9f"
import script from "./message-list.vue?vue&type=script&lang=js"
export * from "./message-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25b5bc9f')) {
      api.createRecord('25b5bc9f', component.options)
    } else {
      api.reload('25b5bc9f', component.options)
    }
    module.hot.accept("./message-list.vue?vue&type=template&id=25b5bc9f", function () {
      api.rerender('25b5bc9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/campaign-scheduling/message-list.vue"
export default component.exports